export default __webpack_public_path__ + "static/media/icon-scholar.ae650ff8.svg";